import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useParams } from 'react-router-dom';
import { useCallback } from 'react';

export const PymtList = ({ payeeCustId }) => {
  
  const { claimType } = useParams();

  const augRowsReq = useCallback((rowsReq) => {

    if (claimType) {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('claimType', claimType.toUpperCase()));
    }

    if (payeeCustId) {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('payeeCustId', payeeCustId));
    }
  }, [claimType, payeeCustId]);

  return (
    <EntityList module="sc" entity="PYMT" augRowsReq={augRowsReq}/>
  )
}
